module.exports = __webpack_public_path__ + "img/30.a7613836.jpg";